import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: '#303030',
    boxShadow: theme.shadows[10],
    padding: theme.spacing(2, 4, 3),
  },
}));
